export const AT_BOARDS_LOADING_SET =        'OPEN_BOARDS_DIALOG_BOARDS_LOADING_SET';
export const AT_BOARDS_SET =                'OPEN_BOARDS_DIALOG_BOARDS_SET';
export const AT_BOARD_SET =                 'OPEN_BOARDS_DIALOG_BOARD_SET';
export const AT_BOARD_UPDATE =              'OPEN_BOARDS_DIALOG_BOARD_UPDATE';
export const AT_BOARDS_DELETE =             'OPEN_BOARDS_DIALOG_BOARDS_DELETE';
export const AT_BOARDS_MOVE =               'OPEN_BOARDS_DIALOG_BOARDS_MOVE';
export const AT_BOARDS_OPENED_SET =         'OPEN_BOARDS_DIALOG_BOARDS_OPENED_SET';
